/**
 * @flow
 */
import { Box } from '@mui/material';
import Attachments from 'components/@home/@messages/ChatPanel/MessagesList/MessageGroup/Attachments';
import React from 'react';

const maxWidth = 500;
const maxHeight = 221;

const AttachmentPreview = ({ attachment }: { attachment: Object }) => {
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        width: 'fit-content',
        backgroundColor: theme.palette.primary.lighter,
        borderRadius: '4px',
        overflow: 'hidden',
      })}
    >
      <Attachments attachments={[attachment]} maxWidth={maxWidth} maxHeight={maxHeight} />
    </Box>
  );
};

export default AttachmentPreview;
